import { onMount, onDestroy } from 'svelte';
import { imageStore, editStore, sessionStore } from '../stores';
import { get } from 'svelte/store';
import features from '../components/features.js';
import { uploadImage } from '../utils/apiClient';

export function useEditorV2Setup() {
  onMount(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = 'hidden';
    const uploadFeature = features.find(f => f.id === 'upload_image');
    const current = get(editStore);
    const savedFeature = features.find(feature => feature.id === current.selectedFeature?.id && !feature.disabled);
    editStore.update(store => ({
      ...store,
      selectedTab: 'edit',
      selectedFeature: savedFeature || uploadFeature
    }));

    const taskCompletedHandler = (event) => {
      const { resultImage, id } = event.detail || {};
      if (id !== get(editStore).currentTaskId) return;
      if (resultImage) {
        imageStore.update(store => ({ ...store, resultImage }));
      }
      editStore.update(store => ({ ...store, isLoading: false }));
    };
    document.addEventListener('taskCompleted', taskCompletedHandler);

    const imgState = get(imageStore);
    if (!imgState.uploadedImageUrl && imgState.serverImageUrl) {
      fetch(imgState.serverImageUrl)
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const file = new File([blob], 'uploaded');
          const img = new Image();
          img.onload = () => {
            imageStore.update(store => ({
              ...store,
              uploadedImageUrl: url,
              uploadedImage: file,
              imageWidth: img.width,
              imageHeight: img.height
            }));
          };
          img.src = url;
        })
        .catch(e => console.error('서버 이미지 로드 오류:', e));
    }

    return () => {
      document.removeEventListener('taskCompleted', taskCompletedHandler);
    };
  });

  onDestroy(() => {
    document.body.style.overflow = '';
  });
}